var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscussions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "mirror-in-rtl": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494c4e",
    d: "M14.994 10c.03 0 .06.005.108.01.504.05.898.485.898.99v6c0 .505-.394.94-.92.992L15 18H8.255l-.563.487L5 20.814V18H3c-.542 0-1-.458-1-1v-6c0-.542.458-1 1-1h11.994M15 8H3c-1.65 0-3 1.35-3 3v6c0 1.65 1.35 3 3 3v3c0 .39.23.75.58.91.14.06.28.09.42.09.24 0 .47-.08.65-.24L9 20h6c.1 0 .21-.01.3-.02 1.51-.15 2.7-1.43 2.7-2.98v-6c0-1.55-1.19-2.83-2.7-2.98-.09-.01-.2-.02-.3-.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#494c4e",
    d: "M24 3v6c0 1.65-1.35 3-3 3-.55 0-1-.45-1-1s.45-1 1-1c.54 0 1-.46 1-1V3c0-.54-.46-1-1-1H9c-.54 0-1 .46-1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V3c0-1.65 1.35-3 3-3h12c1.65 0 3 1.35 3 3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussions);
export default __webpack_public_path__ + "static/media/discussions.8cb1ce7a3b822fd28065e57b7bc4a678.svg";
export { ForwardRef as ReactComponent };